<template>
    <v-container style="height: 100%;">
        <v-layout style="background: rgb(242, 245, 248);">
            <v-flex >
                <div >
                    <v-row>
                        <v-col>
                            <span style="color: #115bb7;font-weight: 600;font-size: 18px;">REPORTE- COMERCIAL</span><br>
                        </v-col>
                    </v-row><br>
                    <v-row style="margin-bottom:16px;">
                        <v-card width="100%">
                            <v-card-text>
                                <v-row style="justify-content: flex-end;">
                                    <v-col>
                                        <v-menu
                                                v-model="vigenciainicio"
                                                :close-on-content-click="false"
                                                max-width="290"
                                                dense
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                    :value="computedDateFormattvigenciainicio"
                                                    clearable
                                                    label="*Inicio"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click:clear="fechavigenciainicio= null"
                                                    dense
                                                    outlined
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="fechavigenciainicio"
                                                    @change="vigenciainicio = false"
                                                ></v-date-picker>
                                            </v-menu>
                                    </v-col>
                                    <v-col>
                                        <v-menu
                                                v-model="vigenciafin"
                                                :close-on-content-click="false"
                                                max-width="290"
                                                dense
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                    :value="computedDateFormattvigenciafin"
                                                    clearable
                                                    label="*Inicio"
                                                    readonly
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    @click:clear="fechavigenciafin= null"
                                                    dense
                                                    outlined
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                    v-model="fechavigenciafin"
                                                    @change="vigenciafin = false"
                                                ></v-date-picker>
                                            </v-menu>
                                    </v-col>
                                    <v-col md="4">
                                        <v-select return-object item-text="text" item-value="value" v-on:change="getEvents" v-model="idusuario" dense outlined label="Usuarios" :items="usuarios"></v-select>
                                    </v-col>
                                </v-row>
                            </v-card-text>                            
                        </v-card>
                    </v-row>
                    <v-row v-if="viewreport == true">
                        <v-col>
                            <v-card>
                                <v-list-item two-line>
                                    <v-list-item-content>                                                        
                                        <v-toolbar flat color="white">
                                            <v-toolbar-title>{{`${this.idusuario.text}`}}</v-toolbar-title>
                                            <v-divider class="mx-4" inset vertical></v-divider>
                                            <span style="color: #115bb7;font-weight: 500;font-size: 20px;">Total Actividades: </span> <span style="color: rgb(33 150 243);font-weight: 500;font-size: 20px;"> {{totalactividades}}</span>
                                            <v-spacer></v-spacer>
                                            <v-btn @click="dialog=true"
                                            text>
                                                <v-icon>visibility</v-icon>
                                            </v-btn>                                                  
                                        </v-toolbar>
                                    </v-list-item-content>
                                </v-list-item> 
                                <v-card-text>                                            
                                    <v-row>
                                        <v-col>
                                            <canvas id="myChart">
                                            </canvas>
                                        </v-col>
                                        <v-col style="display: flex;align-items: center;flex-direction: column;">
                                            <v-row style="width: 100%;">
                                                <v-col style="text-align: center;" md="12" lg="12">
                                                    <div style="width: 100%;text-align: left;display: flex;justify-content: space-evenly;">
                                                        <span style="color: rgb(2 68 150);font-weight: 500;font-size: 18px;">Target -Pendiente</span><br>
                                                        <span style="color: rgb(2 68 150);font-weight: 500;font-size: 18px;">Ventas -Pendiente</span>
                                                    </div>
                                                    <v-progress-circular
                                                    :rotate="360"
                                                    :size="150"
                                                    :width="25"
                                                    :value="value"
                                                    color="#2196F3 !important"
                                                    >
                                                    {{ value }}%
                                                    </v-progress-circular>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>                                             
                                </v-card-text>
                            </v-card>
                        </v-col><br>
                    </v-row>
                    <v-row>
                        <v-col><br>
                            <!--*<v-data-table
                            :headers="headers"
                            :items="reporte"
                            class="elevation-1"
                        ></v-data-table>-->
                        </v-col>
                    </v-row>
                </div>
            </v-flex>
            <template>
                    <v-dialog
                        v-model="dialog"
                        scrollable
                        max-width="800px"
                        >
                        <v-card>
                            <v-toolbar>
                                <v-card-title>Reporte de actividades</v-card-title>
                                <v-spacer></v-spacer>
                                <span style="font-weight: 600;color: #184072;font-size: 20px;">{{`${this.idusuario.text}`}}</span>
                            </v-toolbar>
                            <v-divider></v-divider>
                            <v-card-text style="display: flex;justify-content:center;padding: 25px;" class="d-flex flex-wrap">
                                <v-card width="200px" elevation="5"  style="margin-left: 12px;margin-top: 15px;" md="4">
                                        <div style="display:flex;padding: 5px 20px;">
                                            <v-row>
                                                <v-col md="5" lg="5">
                                                    <v-icon style="color: #E53935;font-size: 35px;font-style: normal;font-weight: 700;">attach_money</v-icon>
                                                </v-col >
                                                <v-col md="7" lg="7" style="font-size: 2em;text-align: right;color: #252422;display: flex;align-items: center;justify-content: flex-end;">
                                                    {{cierre}}
                                                </v-col>
                                            </v-row>
                                        </div>
                                        <v-divider></v-divider>
                                        <div style="display:flex;">
                                            <span style="padding: 8px 8px;font-weight: 500;">Cierre de venta</span>
                                        </div>
                                </v-card>
                                <v-card width="200px" elevation="5"  style="margin-left: 12px;margin-top: 15px;" md="4">
                                        <div style="display:flex;padding: 5px 20px;">
                                            <v-row>
                                                <v-col md="5" lg="5">
                                                    <v-icon style="color: #E53935;font-size: 35px;font-style: normal;font-weight: 700;">star</v-icon>
                                                </v-col >
                                                <v-col md="7" lg="7" style="font-size: 2em;text-align: right;color: #252422;display: flex;align-items: center;justify-content: flex-end;">
                                                    0
                                                </v-col>
                                            </v-row>
                                        </div>
                                        <v-divider></v-divider>
                                        <div style="display: flex;">
                                            <span style="padding: 8px 8px;font-weight: 500;">Cierre de venta cliente nuevo</span>
                                        </div>
                                </v-card>
                                <v-card width="200px" elevation="5"  style="margin-left: 12px;margin-top: 15px;" md="4">
                                        <div style="display:flex;padding: 5px 20px;">
                                            <v-row>
                                                <v-col md="5" lg="5">
                                                    <v-icon style="color: #D84315;font-size: 35px;font-style: normal;font-weight: 700;">insert_drive_file</v-icon>
                                                </v-col >
                                                <v-col md="7" lg="7" style="font-size: 2em;text-align: right;color: #252422;display: flex;align-items: center;justify-content: flex-end;">
                                                    {{cotizacion}}
                                                </v-col>
                                            </v-row>
                                        </div>
                                        <v-divider></v-divider>
                                        <div style="display:flex;">
                                            <span style="padding: 8px 8px;font-weight: 500;">Cotizacion</span>
                                        </div>
                                </v-card>
                                <v-card width="200px" elevation="5"  style="margin-left: 12px;margin-top: 15px;" md="4">
                                        <div style="display:flex;padding: 5px 20px;">
                                            <v-row>
                                                <v-col md="5" lg="5">
                                                    <v-icon style="color: #059ce0;font-size: 35px;font-style: normal;font-weight: 700;">forward_to_inbox</v-icon>
                                                </v-col >
                                                <v-col md="7" lg="7" style="font-size: 2em;text-align: right;color: #252422;display: flex;align-items: center;justify-content: flex-end;">
                                                    {{correos}}
                                                </v-col>
                                            </v-row>
                                        </div>
                                        <v-divider></v-divider>
                                        <div style="display:flex;">
                                            <span style="padding: 8px 8px;font-weight: 500;">Correo</span>
                                        </div>
                                </v-card>
                                <v-card width="200px" elevation="5" md="4" style="margin-left: 12px;margin-top: 15px;">
                                        <div style="display:flex;padding: 5px 20px;">
                                            <v-row>
                                                <v-col md="5" lg="5">
                                                    <v-icon style="color: #41b883;font-size: 35px;font-style: normal;font-weight: 700;">phone</v-icon>
                                                </v-col >
                                                <v-col md="7" lg="7" style="font-size: 2em;text-align: right;color: #252422;display: flex;align-items: center;justify-content: flex-end;">
                                                    {{llamadas}}
                                                </v-col>
                                            </v-row>
                                        </div>
                                        <v-divider></v-divider>
                                        <div style="display:flex;">
                                            <span style="padding: 8px 8px;font-weight: 500;">Llamadas de seguimiento</span>
                                        </div>
                                </v-card>
                                <v-card width="200px" elevation="5"  style="margin-left: 12px;margin-top: 15px;" md="4">
                                        <div style="display:flex;padding: 5px 20px;">
                                            <v-row>
                                                <v-col md="5" lg="5">
                                                    <v-icon style="color:#607D8B;font-size: 35px;font-style: normal;font-weight: 700;">location_on</v-icon>
                                                </v-col >
                                                <v-col md="7" lg="7" style="font-size: 2em;text-align: right;color: #252422;display: flex;align-items: center;justify-content: flex-end;">
                                                    {{visitas}}
                                                </v-col>
                                            </v-row>
                                        </div>
                                        <v-divider></v-divider>
                                        <div style="display:flex;">
                                            <span style="padding: 8px 8px;font-weight: 500;">Visita</span>
                                        </div>
                                </v-card>
                                <v-card width="200px" elevation="5"  style="margin-left: 12px;margin-top: 15px;" md="4">
                                        <div style="display:flex;padding: 5px 20px;">
                                            <v-row>
                                                <v-col md="5" lg="5">
                                                    <v-icon style="color:#00838F;font-size: 35px;font-style: normal;font-weight: 700;">text_snippet</v-icon>
                                                </v-col >
                                                <v-col md="7" lg="7" style="font-size: 2em;text-align: right;color: #252422;display: flex;align-items: center;justify-content: flex-end;">
                                                    {{cp}}
                                                </v-col>
                                            </v-row>
                                        </div>
                                        <v-divider></v-divider>
                                        <div style="display:flex;">
                                            <span style="padding: 8px 8px;font-weight: 500;">Carta de Presentacion</span>
                                        </div>
                                </v-card>
                                <v-card width="200px" elevation="5"  style="margin-left: 12px;margin-top: 15px;" md="4">
                                        <div style="display:flex;padding: 5px 20px;">
                                            <v-row>
                                                <v-col md="5" lg="5">
                                                    <v-icon style="color: #E53935;font-size: 35px;font-style: normal;font-weight: 700;">clear</v-icon>
                                                </v-col >
                                                <v-col md="7" lg="7" style="font-size: 2em;text-align: right;color: #252422;display: flex;align-items: center;justify-content: flex-end;">
                                                    {{nov}}
                                                </v-col>
                                            </v-row>
                                        </div>
                                        <v-divider></v-divider>
                                        <div style="display:flex;">
                                            <span style="padding: 8px 8px;font-weight: 500;">No Viable</span>
                                        </div>
                                </v-card>
                            </v-card-text>
                        </v-card>
                    </v-dialog>
            </template>
        </v-layout>
    </v-container>
</template>
<script>
import Chart from "chart.js"
import axios from 'axios'
export default {
    data(){
        return{
            fechavigenciainicio:null,
            fechavigenciafin:null,
            vigenciafin:false,
            vigenciainicio:false,
            dialog:false,
            dialod:false,
            usuarios:[],
            value:80,
            value2:65,
            hoy:'',
            fechainicio:'',
            fechafin:'',
            cierre:0,
            cotizacion:0,
            correos:0,
            llamadas:0,
            visitas:0,
            cp:0,
            nov:0,
            idusuario:0,
            viewreport:false,
            datacollection: null,
            totalactividades:0,
            headers: [
                {text:'Ejecutivo',sortable: false,value: 'nusuario',align:'center'},
                {text:'Asignacion', value: 'asignacion',align:'center' },
                {text:'Cuentas sin datos completos', value: 'sndatos',align:'center' },
                {text:'No viables', value: 'noviable' ,align:'center'},
                {text:'Cotizaciones clientes', value: 'ccliente' ,align:'center'},
                {text:'Cotizaciones prospectos', value: 'cprospecto' ,align:'center'},
                {text:'Visita clientes', value: 'vcliente' ,align:'center'},
                {text:'Visita prospectos', value: 'vprospecto' ,align:'center'},
                {text:'Promedio (actividades por dia en agenda)', value: 'promedioa' ,align:'center'},
                {text:'Actividades penientes', value: 'apendientes' ,align:'center'},
                {text:'Ventas clientes', value: 'ventasc' ,align:'center'},
                {text:'Ventas Nuevas', value: 'ventasp' ,align:'center'},
            ],
            reporte:[],
            ntarget:0,
            finicio:null,
            ffin:null
        }
    },
    computed: {
        computedDateFormattvigenciafin () {
            return this.formatDate(this.fechavigenciafin)
        },
        computedDateFormattvigenciainicio () {
            return this.formatDate(this.fechavigenciainicio)
        },
    },
    methods:{
        async target(){
          let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
          let header={"Authorization" : "Bearer " + this.$store.state.token};
          let configuracion ={headers:header};
          var arrayTarget = [];
          await axios.get('api/targets/Select/' + me.$store.state.usuario.idusuario,configuracion).then(async function(response){
            arrayTarget=response.data;
            arrayTarget.map(function(x){
              me.ntarget = x.rate;
              me.finicio = x.nvigenciainicio;
              me.ffin = x.nvigenciafin;
            });
            this.getEvents();
          }).catch(function(error){
            console.log(error);
          });
        },
        loadActividades(){
            var ctx = document.getElementById('myChart');
            var myChart = new Chart(ctx, {
                type: 'bar',
                data: {
                    labels: ['Cierre de Venta','Cliente nuevo','Cotizaciones', 'Correos','Llamadas', 'Visitas', 'Cartas de presentación', 'No Viables'],
                    datasets: [{
                        label: 'Actividades en el ultimo mes',
                        //data: [5,8,2, 4, 9, 5, 2, 11],
                        data: [10, 0,8, 15, 22, 14, 16,3],
                        backgroundColor: [
                            'rgba(255, 99, 132, 0.2)',
                            'rgba(54, 162, 235, 0.2)',
                            'rgba(255, 206, 86, 0.2)',
                            'rgba(75, 192, 192, 0.2)',
                            'rgba(153, 102, 255, 0.2)',
                            'rgba(255, 159, 64, 0.2)',
                            'rgba(255, 99, 132, 0.2)',
                            'rgba(54, 162, 235, 0.2)',
                            'rgba(255, 206, 86, 0.2)',
                            'rgba(75, 192, 192, 0.2)',
                            'rgba(153, 102, 255, 0.2)',
                            'rgba(255, 159, 64, 0.2)'
                        ],
                        borderColor: [
                            'rgba(255, 99, 132, 1)',
                            'rgba(54, 162, 235, 1)',
                            'rgba(255, 206, 86, 1)',
                            'rgba(75, 192, 192, 1)',
                            'rgba(153, 102, 255, 1)',
                            'rgba(255, 159, 64, 1)',
                            'rgba(255, 99, 132, 1)',
                            'rgba(54, 162, 235, 1)',
                            'rgba(255, 206, 86, 1)',
                            'rgba(75, 192, 192, 1)',
                            'rgba(153, 102, 255, 1)',
                            'rgba(255, 159, 64, 1)'
                        ],
                        borderWidth: 1
                    }]
                },
                options: {
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    }
                }
            });
        },
        select(){
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var usuariosarray = [];

            axios.get('api/Usuarios/SelectReport',configuracion).then(function(response){
                usuariosarray=response.data;
                usuariosarray.map(function(x){
                    me.usuarios.push({text:x.nombre,value:x.idusuario});
                });            
            }).catch(function(error){
                console.log(error);
            }); 
        },
        async getEvents(){
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion         
            let header={"Authorization" : "Bearer " + me.$store.state.token};        
            let configuracion ={headers:header};
            var events = []
            me.reporte = [];
            me.hoy = new Date();
            var mes;
                if(me.hoy.getMonth() < 9 ){
                    mes = '0' + (me.hoy.getMonth() + 1);   
                }else{
                    mes = me.hoy.getMonth() + 1;
                }
            var diasMes = new Date(me.hoy.getFullYear(), mes, 0).getDate();
            var inicio;
            var fin;
            inicio = '01'+ '/' + mes + '/' + me.hoy.getFullYear();
            fin = diasMes + '/' + mes + '/' + me.hoy.getFullYear();
            if(me.fechavigenciainicio  == null){
                    me.fechavigenciainicio = me.finicio;
                    me.fechavigenciainicio =  me.ffin;
            }
            await axios.get('api/Actividades/ListarActividadAdministrador/' + me.idusuario.value + '/' + me.fechavigenciainicio + '/' + me.fechavigenciafin,
            configuracion).then(async function(response){
                events=response.data;
                //console.log('events')
                //console.log(events)
                //me.totalactividades = events.length;
                var cierre = 0;
                var cotizacion = 0;
                var correos = 0;
                var llamadas = 0;
                var visitas = 0;
                var cp = 0;
                var nov = 0;
                /*await events.map(function(x){
                    if(x.idtipo_actividad == 1){
                        correos = correos + 1;
                    }
                    if(x.idtipo_actividad == 2){
                        llamadas = llamadas + 1;
                    }
                    if(x.idtipo_actividad == 3){
                        visitas = visitas + 1;
                    }
                    if(x.idtipo_actividad == 4){
                        cotizacion = cotizacion + 1;
                    }
                    if(x.idtipo_actividad == 5){
                        nov = nov + 1;
                    }
                    if(x.idtipo_actividad == 6){
                        cp = cp + 1;
                    }
                    if(x.idtipo_actividad == 8){
                        cierre = cierre + 1;
                    }
                });*/
                var asignacion = 0;
                var noviable = 0;
                var ccliente = 0;
                var cprospecto = 0;
                var vcliente = 0;
                var vprospecto = 0;
                var apendientes = 0;
                
                await events.map(function(x){
                    asignacion = x.asignadas
                    if(x.idtipo_actividad == 5){
                        noviable = noviable + 1;
                    }
                    if(x.escliente == true){
                        if(x.idtipo_actividad == 4){
                            ccliente = ccliente + 1;
                        }
                        if(x.idtipo_actividad == 3){
                            vcliente = vcliente + 1;
                        }
                    }else{
                        if(x.idtipo_actividad == 4){
                            cprospecto = cprospecto + 1;
                        }
                        if(x.idtipo_actividad == 3){
                            vprospecto = vprospecto + 1;
                        }
                    }
                    if(x.completada == false){
                        apendientes = apendientes + 1;
                    }
                });

                me.correos = correos;
                me.llamadas = llamadas;
                me.visitas = visitas;
                me.cotizacion = cotizacion;
                me.nov = nov;
                me.cp = cp;
                me.cierre = cierre;
                me.viewreport = true;
                me.reporte.push({
                    nusuario:'',
                    asignacion:asignacion,
                    sndatos:'',
                    noviable:noviable,
                    ccliente:ccliente,
                    cprospecto:cprospecto,
                    vcliente:vcliente,
                    vprospecto:visitas,
                    promedioa:'',
                    apendientes:apendientes,
                    ventasc:'',
                    ventasp:''
                });

                me.loadActividades();
            }).catch(function(error){
                console.log(error);
            });
        },
        formatDate(date){
            if (!date) return null
            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
    },
    created(){
        this.select();
        this.target();
        //this.getEvents();
    },
    mounted(){
        //this.loadActividades();
    },

}
</script>